<template>
  <div class="container-fluid pb-2">
    <ValidationObserver ref="form">
      <div class="row">
        <div class="col-12 mb-4">
          <i class="fa fa-info-circle mr-2 text-orange" />
          <label class="input-label text-gray mb-3">
            Razón de Regresar Estatus:
          </label>
          <ValidationProvider
            v-slot="{ errors }"
            name="returnStateReason"
            :rules="'required'"
          >
            <CustomTextArea
              id="returnStateReason"
              v-model="returnStateReason"
              :maxlength="3000"
              :classes="['eq-field', 'text-right']"
              :rows="5"
              :error="errors[0]"
              custom-error-msg="Favor escriba una razón."
            />
          </ValidationProvider>
        </div>
        <div class="col-12 mt-auto">
          <div :class="['d-flex justify-content-end', { 'pt-3': isMobile }]">
            <ActionButton
              :class="['mr-2 btn-transparent', { 'w-100': isMobile }]"
              variant="outline-danger"
              text="Cancelar"
              i="fas fa-times-circle mx-auto"
              @click="cancel"
            />
            <ActionButton
              :class="{ 'w-100': isMobile }"
              variant="success"
              text="Guardar"
              i="fas fa-save mx-auto"
              @click="save"
            />
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import { undoStatus } from '@/modules/books-requests/api';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'StatusReturnReason',
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomTextArea,
  },
  data() {
    return {
      returnStateReason: null,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel-return-status');
    },
    refreshSearch() {
      this.$emit('success-return-status');
      this.cancel();
    },
    async save() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea regresar determinación al estatus ${this.value.previousStatus}?`
        );

        const book = {
          bookId: this.value.bookId,
          academicYearId: this.value.academicYearId,
          studentSieId: this.value.studentSieId,
          returnStateReason: this.returnStateReason,
        };

        if (answer) {
          undoStatus(book)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'El estatus fue actualizado exitosamente.',
                  'success'
                );
                this.refreshSearch();
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
